<template>
  <van-dialog
    v-model="show"
    class="dialog"
    show-cancel-button
    @close="confirm"
    @confirm="confirm"
  >
    <van-form style="position: relative; margin-top: 1rem">
      <van-cell-group inset>
        <van-sticky>
          <van-field v-model="form.code" name="code" label="零售出库单号" />
          <van-cell @click="showStockSelect">
            <van-field
              v-model="form.scName"
              inputmode="none"
              name="scName"
              label="仓库"
          /></van-cell>
          <van-cell @click="showMemberSelect">
            <van-field
              v-model="form.memberName"
              inputmode="none"
              name="memberName"
              label="会员"
          /></van-cell>
          <van-cell>
            <van-button :loading="loading" type="primary" @click="search"
              >查询</van-button
            >
          </van-cell>
        </van-sticky>
      </van-cell-group>
      <div class="tableBox">
        <CustomTable
          ref="table"
          :scrollWidth="600"
          :columns="columns"
          :tableData="tableData"
          @selectedRowChange="showActive"
          :total="totalCount"
          :pageIndex="pageIndex"
          :pageSize="pageSize"
          @pageChange="pageChange"
        ></CustomTable>
      </div>
      <StockSelect
        :visible="stockSelectVisible"
        @confirm="stockSelectConfirm"
      ></StockSelect>
      <!-- 会员选择弹窗   -->
      <!-- <MemberSelect
        :visible="memberSelectVisible"
        @confirm="memberSelectConfirm"
      ></MemberSelect> -->
    </van-form>
    <!-- <van-cell style="position: absolute;bottom:0;">
      <van-button round block type="primary" @click="confirm">
        提交
      </van-button>
    </van-cell> -->
  </van-dialog>
</template>
<script>
import { AVAILABLE } from "../utils/constants";
import { queryWithReturn } from "../service/api/retail/out";
import StockSelect from "./stockSelect.vue";
// import MemberSelect from "./memberSelect.vue";
import CustomTable from "./customTable.vue";
// 导入样式
export default {
  name: "returnOutSheetSelect",
  components: {
    StockSelect,
    // MemberSelect,
    CustomTable,
  },
  props: {
    visible: false,
  },
  data() {
    return {
      memberSelectVisible: false,
      stockSelectVisible: false,
      loading: true,
      show: false,
      data: [],
      form: { code: "", name: "" },
      pageSize: 20,
      pageIndex: 1,
      totalCount: 0,
      totalPage: 1,
      columns: [
        {
          field: "name",
          key: "b",
          // type=radio
          type: "radio",
          title: "单选",
          width: 30,
          align: "left",
        },
        { field: "code", width: 100, key: "code", title: "零售出库单号" },
        { width: 100, field: "scCode", key: "scCode", title: "仓库编号" },
        { width: 100, field: "scName", key: "scName", title: "仓库名称" },
        // {
        //   width: 100,
        //   field: "memberCode",
        //   key: "memberCode",
        //   title: "会员编号",
        // },
        // {
        //   width: 100,
        //   field: "memberName",
        //   key: "memberName",
        //   title: "会员名称",
        // },
        {
          width: 100,
          field: "createTime",
          key: "createTime",
          title: "操作时间",
        },
        // { field: "createBy", key: "createBy", title: "操作人" },
      ],
      tableData: [],
      statusList: AVAILABLE,
      categoryList: [],
      currentRow: {},
    };
  },
  watch: {
    visible(newVal, oldVal) {
      this.show = newVal;
      this.$nextTick(() => {
        this.$refs.table && this.$refs.table.unselectedAll();
      });
    },
  },
  created() {
    this.search();
  },
  methods: {
    showStockSelect() {
      this.stockSelectVisible = true;
    },
    stockSelectConfirm(row) {
      if (Object.keys(row).length === 0) {
        this.stockSelectVisible = false;
        return;
      }
      this.stockSelectVisible = false;
      this.form.scName = row.name;
      this.form.scId = row.id;
    },
    showMemberSelect() {
      this.memberSelectVisible = true;
    },
    memberSelectConfirm(row) {
      if (Object.keys(row).length === 0) {
        this.memberSelectVisible = false;
        return;
      }
      this.memberSelectVisible = false;
      this.form.memberName = row.name;
      this.form.memberId = row.id;
    },
    search() {
      this.getProductList();
      // this.categoryList = this.data.filter((el) => {
      //
      //   return el.code.includes(this.form.code)&&el.name.includes(this.form.name)
      // });
    },
    showActive(item) {
      this.currentRow = item;
    },
    confirm() {
      this.$emit("confirm", this.currentRow);
      this.show = false;
      this.currentRow = {};
    },
    pageChange(pageOptions) {
      this.pageIndex = pageOptions.pageIndex;
      this.pageSize = pageOptions.pageSize;
      this.getProductList();
    },
    getProductList() {
      this.loading = true;
      const params = Object.assign({}, this.form, {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      });
      queryWithReturn(params).then((res) => {
        this.tableData = res.data.datas;
        this.loading = false;
        this.totalCount = res.data.totalCount;
        this.totalPage = res.data.totalPage;
        this.pageSize = res.data.pageSize;
        this.pageIndex = res.data.pageIndex;
      });
    },
  },
};
</script>
<style lang="less" scoped>
.active {
  background: #1989fa;
}
.dialog {
  height: 85%;
}
// .van-cell_title {
//   color: #333;
//   font-size: 12px;
// }
::v-deep .van-dialog__content {
  height: 100%;

  // .van-form {
  //   height: 100%;
  // }
}
.tableBox {
  height: calc(100vh - 377px);
  overflow: hidden;
}
.scrollList {
  height: calc(100% - 185px) !important;
  overflow: auto;
}
::v-deep .van-dialog__footer {
  position: sticky;
  bottom: 0;
}
::v-deep .van-cell {
  padding: 2px 10px !important;
}
</style>
